import React, { Component } from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import {
  Form,
  Input,
  Row,
  Col,
  Button,
  Card,
  message,
  Popover,
  Select,
} from "antd";
import Amplify, { Auth } from "aws-amplify";
import AppConfigs from "../../Config/AppConfig";
import { add } from "../../api/Apis";
import { noWhitespaceRule, notValidPhoneNumberRule } from "../../utils/Utils";
import ErrorPage from "../ErrorPage";

Amplify.configure({
  Auth: {
    // REQUIRED - Amazon Cognito Identity Pool ID
    identityPoolId: `${AppConfigs.APP_IDENTITY_POOL_ID}`,
    // REQUIRED - Amazon Cognito Region
    region: `${AppConfigs.APP_COGNITO_REGION}`,
    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: `${AppConfigs.APP_COGNITO_USER_POOL_ID}`,
    // OPTIONAL - Amazon Cognito Web Client ID
    userPoolWebClientId: `${AppConfigs.APP_CLIENT_ID}`,
  },
});
const Option = Select;
class AddUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      confirmDirty: false,
      fileList: [],
      userDetails:JSON.parse(localStorage.getItem("userDetails"))
    };
  }
  hasErrors = (fieldsError) =>
    Object.keys(fieldsError).some((field) => fieldsError[field]);

  handleSubmit = (e) => {
    e.preventDefault();
    let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.setState({
          loading: true,
        });
        let data = {
          entityData: {
            firstName: values["firstName"],
            lastName: values["lastName"],
            email: values["email"],
            phone: values["phone"],
            orgId: orgDetails["id"],
            userProfile: values["userProfile"],
            recordStatus: true,
            isActive: false,
          },
        };
        this.addUser(values["email"], values["password"], data);
      }
    });
  };

  addUser = async (email, password, regData) => {
    await Auth.signUp({
      username: email,
      password: password,
    })
      .then((data) => {
        regData["entityData"]["id"] = data.userSub;
        add(AppConfigs["entityNames"]["users"], regData).then((result) => {
          if (result.success) {
            message.success(`User created successfully.`);
            this.props.history.push("/app/settings");
          } else {
            console.log(result.errors);
          }
        });
      })
      .catch((err) => {
        if (err.code === "InvalidPasswordException") {
          alert(
            "Invalid Password: \n- Minimum password length:6\n- Require at least one uppercase letter\n- Require at least one lowercase letter\n- Require at least one number\n- Require at least one nonalphanumeric character"
          );
          this.setState({ value: true, loading: false });
        } else {
          alert(err.message);
          this.setState({ value: true, loading: false });
        }
      });
  };

  handleConfirmBlur = (e) => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };
  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue("password")) {
      callback("Two passwords that you enter is inconsistent!");
    } else {
      callback();
    }
  };

  validateToNextPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && this.state.confirmDirty) {
      form.validateFields(["confirm"], { force: true });
    }
    callback();
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    let passwordCriteria = (
      <div>
        <Row>
          <Col lg={24} md={24} sm={24} xs={24}>
            -Minimum password length: 6 <br />
            -Required at least one uppercase letter
            <br />
            -Required at least one lowercase letter
            <br />
            -Required at least one number
            <br />
            -Required at least one nonalphanumeric character
            <br />
          </Col>
        </Row>
      </div>
    );
   
    if (this.state.userDetails.userProfile !== "A") {
      return (
       <ErrorPage/>
      );
    }

    return (
      <div
        style={{
          position: "absolute",
          top: "143px",
          paddingLeft: "25%",
          paddingRight: "25%",
        }}
      >
        <Col lg={12} md={12} sm={24} xs={24} offset={6}>
          <div className="site-card-border-less-wrapper">
            <Form onSubmit={this.handleSubmit}>
              <Card
                title={<h4 className="Companyheadinglabel">Add User</h4>}
                style={{ borderRadius: "10px" }}
              >
                <Row gutter={10}>
                  <Col lg={24} md={24} sm={24} sx={24}>
                    <Form.Item
                      className="Formitem"
                      label={
                        <span style={{ color: "#7B8190", fontSize: "14px" }}>
                          First Name
                        </span>
                      }
                    >
                      {getFieldDecorator("firstName", {
                        rules: [
                          {
                            required: true,
                            message: "Please input your First Name!",
                          },
                          noWhitespaceRule,
                        ],
                      })(<Input />)}
                    </Form.Item>
                  </Col>
                  <Col lg={24} md={24} sm={24} sx={24}>
                    <Form.Item
                      className="Formitem"
                      label={
                        <span style={{ color: "#7B8190", fontSize: "14px" }}>
                          Last Name
                        </span>
                      }
                    >
                      {getFieldDecorator("lastName", {
                        rules: [
                          {
                            required: true,
                            message: "Please input your Last Name!",
                          },
                          noWhitespaceRule,
                        ],
                      })(<Input />)}
                    </Form.Item>
                  </Col>
                  <Col lg={24} md={24} sm={24} sx={24}>
                    <Form.Item
                      className="Formitem"
                      label={
                        <span style={{ color: "#7B8190", fontSize: "14px" }}>
                          Email
                        </span>
                      }
                    >
                      {getFieldDecorator("email", {
                        rules: [
                          {
                            required: true,
                            type: "email",
                            message: "Please input your Email!",
                          },
                        ],
                      })(<Input />)}
                    </Form.Item>
                  </Col>
                  <Col lg={24} md={24} sm={24} sx={24}>
                    <Form.Item
                      className="Formitem"
                      label={
                        <span style={{ color: "#7B8190", fontSize: "14px" }}>
                          Phone
                        </span>
                      }
                    >
                      {getFieldDecorator("phone", {
                        rules: [
                          {
                            required: true,
                            message: "Please input your Phone Number!",
                          },
                          noWhitespaceRule,
                          notValidPhoneNumberRule
                        ],
                      })(<Input />)}
                    </Form.Item>
                  </Col>
                  <Col lg={24} md={24} sm={24} sx={24}>
                    <Form.Item
                      className="Formitem"
                      label={
                        <span style={{ color: "#7B8190", fontSize: "14px" }}>
                          User Profile
                        </span>
                      }
                    >
                      {getFieldDecorator("userProfile", {
                        rules: [
                          {
                            required: true,
                            message: "Please input your User Profile!",
                          },
                        ],
                        // initialValue:
                        //   this.state.userData.userProfile === "A"
                        //     ? "Admin"
                        //     : this.state.userData.userProfile === "M"
                        //     ? "Manager"
                        //     : "",
                      })(
                        <Select>
                          <Option value="A">Admin</Option>
                          <Option value="M">Manager</Option>
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      className="Formitem"
                      label={<span className="label">Password</span>}
                    >
                      {getFieldDecorator("password", {
                        rules: [
                          {
                            required: true,
                            message: "Please input your password!",
                          },
                          noWhitespaceRule,
                          { validator: this.validateToNextPassword },
                        ],
                      })(
                        <Input.Password
                          placeholder="*********"
                          autoComplete="new-password"
                        />
                      )}
                    </Form.Item>
                    <Popover
                      placement="top"
                      title={
                        <h2 style={{ textAlign: "center" }}>
                          Password Criteria
                        </h2>
                      }
                      content={passwordCriteria}
                      trigger="hover"
                    >
                      <span style={{ color: "#20a8d8" }}>Criteria</span>
                    </Popover>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      className="Formitem"
                      label={<span className="label">Confirm Password</span>}
                    >
                      {getFieldDecorator("confirm", {
                        rules: [
                          {
                            required: true,
                            message: "Please confirm your password!",
                          },
                          { validator: this.compareToFirstPassword },
                          noWhitespaceRule,
                        ],
                      })(
                        <Input.Password
                          placeholder="*********"
                          onBlur={this.handleConfirmBlur}
                        />
                      )}
                    </Form.Item>
                  </Col>
                  {/* <Col lg={12} md={12} sm={24} sx={24}>
                                        <Form.Item className="Formitem"
                                            label={<span style={{ color: '#7B8190', fontSize: '14px' }}>Zip</span>}>
                                            {getFieldDecorator('zip', {
                                                rules: [{ required: true, message: 'Please input Location Zip!' }],
                                            })(<Input setFieldsValue={this.state.zip} />)}
                                        </Form.Item>
                                    </Col> */}
                  {/* <Col lg={12} md={12} sm={24} xs={24} >
                                        <Form.Item label={<span style={{ color: '#7B8190', fontSize: '14px' }}>Photo</span>}
                                        >
                                            {getFieldDecorator('map', {
                                                rules: [{ required: true, message: 'Please upload Photo!' }],
                                            })(
                                                <div className="addlocation-uploadbtn">
                                                    <Upload {...props} setFieldsValue={this.state.sizeUploadImg}>
                                                        <Button>
                                                            <Icon type="upload" />Upload
                                                </Button>
                                                    </Upload>
                                                </div>
                                            )}
                                        </Form.Item>

                                    </Col> */}
                </Row>
              </Card>
              <Row>
                <Form.Item style={{ marginTop: "5%" }}>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "#25559517",
                      color: "#255595",
                      marginRight: "30px",
                      padding: "0 20px 0 20px",
                      border: "none",
                    }}
                  >
                    <Link to="/app/settings">Cancel</Link>
                  </Button>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={this.state.loading}
                    onClick={this.handleSubmit}
                    style={{
                      float: "right",
                      backgroundColor: "#255595",
                      color: "white",
                      padding: "0 20px 0 20px",
                    }}
                  >
                    Save
                  </Button>
                </Form.Item>
              </Row>
            </Form>
          </div>
        </Col>
      </div>
    );
  }
}
export default Form.create({ name: "adduser" })(withRouter(AddUser));
